import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import './index.css';

import Login                from './pages/Login';
import Dashboard            from './pages/Dashboard';
import CreatePayment        from './pages/CreatePayment';
import Transactions         from './pages/Transactions';
import PaymentStatus        from './pages/PaymentStatus';
import AdminManagement      from './pages/AdminManagement';
import PowerPaymentForm     from './pages/PowerPaymentForm';
import PowerPaymentDashboard from './pages/PowerPaymentDashboard';
import SecurityDepositForm from './pages/SecurityDepositForm';
import SecurityDepositForm2 from './pages/SecurityDepositForm2';
import SecurityDepositDashboard from './pages/SecurityDepositDashboard';
import NocDashboard from './pages/NocDashboard';
const PrivateRoute = ({ children }) => {
  const { isLoggedIn } = useAuth();
  return isLoggedIn ? children : <Navigate to="/login" replace />;
};

const PublicRoute = ({ children }) => {
  const { isLoggedIn } = useAuth();
  return isLoggedIn ? <Navigate to="/dashboard" replace /> : children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/"               element={<Navigate to="/dashboard" replace />} />

      {/* Truly public — accessible whether logged in or not */}
      <Route path="/powerpayment"   element={<PowerPaymentForm />} />
      <Route path="/payment/status" element={<PaymentStatus />} />
      <Route path="/security-deposit" element={<SecurityDepositForm />} />
      <Route path="/mybad/security-deposit" element={<SecurityDepositForm2 />} />

      {/* Login — redirects to dashboard if already logged in */}
      <Route path="/login"          element={<PublicRoute><Login /></PublicRoute>} />

      {/* Protected admin routes */}
      <Route path="/dashboard"        element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      <Route path="/create-payment"   element={<PrivateRoute><CreatePayment /></PrivateRoute>} />
      <Route path="/transactions"     element={<PrivateRoute><Transactions /></PrivateRoute>} />
      <Route path="/admins"           element={<PrivateRoute><AdminManagement /></PrivateRoute>} />
      <Route path="/power-dashboard"  element={<PrivateRoute><PowerPaymentDashboard /></PrivateRoute>} />
      <Route path="/security-deposit-dashboard" element={<PrivateRoute><SecurityDepositDashboard /></PrivateRoute>} />
      <Route path="/noc-dashboard"    element={<PrivateRoute><NocDashboard /></PrivateRoute>} />

      <Route path="*"               element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: '#1a1a2e',
              color: '#f0f0ff',
              border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: 10,
              fontSize: 14,
            },
            success: { iconTheme: { primary: '#00d68f', secondary: '#1a1a2e' } },
            error:   { iconTheme: { primary: '#ff4757', secondary: '#1a1a2e' } },
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}